import { render, staticRenderFns } from "./MessagesLog.vue?vue&type=template&id=73eb474f&"
import script from "./MessagesLog.vue?vue&type=script&lang=js&"
export * from "./MessagesLog.vue?vue&type=script&lang=js&"
import style0 from "./MessagesLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
